export const cleanObject = obj => {
  if (
    obj === null ||
    typeof obj !== 'object' ||
    obj instanceof Date ||
    obj instanceof FormData
  ) {
    return obj;
  }

  return Object.keys(obj).reduce((acc, key) => {
    const value = obj[key];

    const cleanedValue =
      value !== null && typeof value === 'object' && !Array.isArray(value)
        ? cleanObject(value)
        : value;

    const isEmpty =
      cleanedValue === null ||
      cleanedValue === undefined ||
      cleanedValue === '';

    const isEmptyObject =
      cleanedValue !== null &&
      typeof cleanedValue === 'object' &&
      !Array.isArray(cleanedValue) &&
      Object.keys(cleanedValue).length === 0;

    if (!isEmpty && !isEmptyObject) {
      acc[key] = cleanedValue;
    }

    return acc;
  }, {});
};
